import { render, staticRenderFns } from "./doctor-times.vue?vue&type=template&id=5ec7d833&"
import script from "./doctor-times.vue?vue&type=script&lang=js&"
export * from "./doctor-times.vue?vue&type=script&lang=js&"
import style0 from "./doctor-times.vue?vue&type=style&index=0&id=5ec7d833&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports